import React, {Component} from 'react'
import {Col, Icon, Row} from 'antd';
import computerImage from '../../img/laptop.svg';
import peopleImage from '../../img/people-fill.svg';
import {ETIQUETA_HOME_GRAFICA_TOTAL_ASPIRANTES_REGISTRADOS, ETIQUETA_HOME_GRAFICA_NO_PARTICIPA_ENTIDAD, ETIQUETA_HOME_GRAFICA_NO_PARTICIPA_DISTRITO} from '../../ApplicationResources';
import { ReactSVG } from 'react-svg'
import Text from 'antd/lib/typography/Text';

class Mapa extends Component {
    constructor(props) {
        super(props);
    }

    obtenerNombreMapa = () => {
        const {idEstado} = this.props;

        if(idEstado > 0)
            return require('../../img/svg/estado-' + idEstado + '/estado-' + idEstado + '.svg').default;
        return require('../../img/svg/Mapa_federal.svg').default;;
    }

    render() {
        const {totalAspirantes,totalRegLinea,totalRegJd, participa, idEstado, idDistrito} = this.props;

        var mensajeNoParticipa = "";

        if(idEstado > 0 && idDistrito === 0)
            mensajeNoParticipa = ETIQUETA_HOME_GRAFICA_NO_PARTICIPA_ENTIDAD;
        else if(idEstado > 0 && idDistrito > 0)
            mensajeNoParticipa = ETIQUETA_HOME_GRAFICA_NO_PARTICIPA_DISTRITO;

        return(
        <div>
          <Col  sm={24} md={24} lg={24}>
            <div className="grafica_home_total_aspirantes_registrados">
              {participa ? ETIQUETA_HOME_GRAFICA_TOTAL_ASPIRANTES_REGISTRADOS : ''}
            </div>
          </Col>
          <Col  sm={24} md={24} lg={24}>
            <div className={ participa ? 'grafica_home_total_aspirantes_registrados_cantidad' : 'grafica_home_total_aspirantes_registrados_cantidad grafica_home_no_participa'}>
                { 
                    participa ? new Intl.NumberFormat('en-US', { style: 'decimal', currency: 'USD' }
                              ).format(totalAspirantes) : mensajeNoParticipa
                }
            </div>
          </Col>
          <Col  sm={24} md={24} lg={24}>
            <Row>
                <Col  sm={12} md={12} lg={12}>                
                    <div className='grafica_home_mapa'>
                        <ReactSVG 
                            src={this.obtenerNombreMapa()} 
                            className={participa ? 'mapa' : 'mapa imagen_deshabilitada'}
                        />
                    </div>
                </Col>
                
                <Col  sm={12} md={12} lg={12}>
                <div className='grafica_home_tabla_mapa_estadisticas'>
                    <div className='columnas_estadisticos'>
                    <Col sm={24} md={24} lg={24}>
                        <Col sm={24} md={24} lg={24}>
                            <Col  sm={4} md={4} lg={4}>
                            </Col>
                            <Col  sm={20} md={20} lg={20}>
                                <Text style={{color: '#139ce5', fontWeight: 'bold'}}><Icon type="info-circle" theme="filled" style={{fontSize: '1.0em'}} /> Inicia la consulta, selecciona el estado y el proceso vigente.</Text>
                            </Col>
                        </Col>

                        <Col sm={24} md={24} lg={24}>
                            <Col  sm={4} md={4} lg={4}>
                                <div className='grafica_home_iconos_tabla_estadistica'>
                                    <img src={computerImage} className="iconos_estadistica" />
                                </div>
                            </Col>
                            <Col  sm={20} md={20} lg={20}>
                                <div className='grafica_home_etiqueta_total_aspirantes_registrados'>
                                    Aspirantes registrados en línea
                                </div>
                            </Col>
                        </Col>
                        <Col  sm={24} md={24} lg={24}>
                            <Col  sm={4} md={4} lg={4}>
                            </Col>
                            <Col  sm={20} md={20} lg={20}>
                                <div className={participa ? 'grafica_home_total_aspirantes_registrados_cantidad tabla_estadistica' : 'grafica_home_total_aspirantes_registrados_cantidad tabla_estadistica tabla_estadistica_no_participa'}>
                                    { 
                                        participa ? new Intl.NumberFormat('en-US', { style: 'decimal', currency: 'USD' }
                                                ).format(totalRegLinea) : '-'
                                    }
                                </div>
                            </Col>
                        </Col>
                        <Col  sm={24} md={24} lg={24}>
                            <Col  sm={4} md={4} lg={4}>
                                <div className='grafica_home_iconos_tabla_estadistica'>
                                    <img src={peopleImage} className="iconos_estadistica" />
                                </div>
                            </Col>
                            <Col  sm={20} md={20} lg={20}>
                                <div className='grafica_home_etiqueta_total_aspirantes_registrados'>
                                    Aspirantes registrados en JDE
                                </div>                        
                            </Col>
                        </Col>
                        <Col  sm={24} md={24} lg={24}>
                            <Col  sm={4} md={4} lg={4}>
                            </Col>
                            <Col  sm={20} md={20} lg={20}>
                                <div className={participa ? 'grafica_home_total_aspirantes_registrados_cantidad tabla_estadistica' : 'grafica_home_total_aspirantes_registrados_cantidad tabla_estadistica tabla_estadistica_no_participa'}>
                                    { 
                                        participa ? new Intl.NumberFormat('en-US', { style: 'decimal', currency: 'USD' }
                                                ).format(totalRegJd) : '-'
                                    }
                                </div>
                            </Col>
                        </Col>
                    </Col>
                    </div>
                </div>
                </Col>
            </Row>
            

          </Col>
        </div>
        )
    }
};

export default (Mapa);